// Mirror of the server role matrix (backend/security_core.py is authoritative; the server sends the live list in /auth/me).

export const ALL_PERMS = [
  "matter.view", "matter.edit", "matter.create", "matter.assign", "matter.close",
  "client.view", "client.edit",
  "document.view", "document.upload", "document.edit", "document.delete",
  "strategy.view", "notes.private.view",
  "research.view", "research.edit", "draft.view", "draft.edit", "draft.approve", "task.edit",
  "billing.view", "billing.edit", "billing.margins.view",
  "odr.view", "odr.caucus.view",
  "automation.view", "automation.manage",
  "opportunities.view", "opportunities.manage", "notification.create",
  "admin.view", "team.manage", "audit.view",
];

const ADVOCATE = [
  "matter.view", "matter.edit", "matter.create", "matter.assign", "matter.close",
  "client.view", "client.edit", "document.view", "document.upload", "document.edit", "document.delete",
  "strategy.view", "notes.private.view", "research.view", "research.edit", "draft.view", "draft.edit", "task.edit",
  "billing.view", "billing.edit", "odr.view", "odr.caucus.view", "automation.view",
  "opportunities.view", "opportunities.manage", "notification.create",
];

export const ROLE_PERMISSIONS = {
  "Managing Partner": ALL_PERMS,
  "Senior Advocate": [...ADVOCATE, "draft.approve", "billing.margins.view", "team.manage", "admin.view", "audit.view"],
  Advocate: [...ADVOCATE, "draft.approve"],
  "Junior Advocate": [
    "matter.view", "matter.edit", "client.view", "document.view", "document.upload", "document.edit",
    "strategy.view", "research.view", "research.edit", "draft.view", "draft.edit", "task.edit", "odr.view",
    "automation.view", "opportunities.view", "notification.create",
  ],
  Clerk: [
    "matter.view", "client.view", "document.view", "document.upload", "research.view", "draft.view", "task.edit", "notification.create",
  ],
  "Firm Admin": [
    "matter.view", "client.view", "client.edit", "document.view", "billing.view",
    "billing.edit", "billing.margins.view", "team.manage", "admin.view", "audit.view", "automation.view",
    "automation.manage", "opportunities.view", "opportunities.manage", "notification.create", "draft.view",
  ],
  Client: ["matter.view", "document.view", "billing.view", "odr.view"],
  "ODR Neutral": ["odr.view", "odr.caucus.view", "document.view"],
};

export const hasPerm = (role, perm) => (ROLE_PERMISSIONS[role] || []).includes(perm);

export const PERSONAS = [
  { role: "Managing Partner", name: "Satish Kumar Adusumilli", org: "Adusumilli & Associates" },
  { role: "Senior Advocate", name: "Satish Kumar Adusumilli", org: "Adusumilli & Associates" },
  { role: "Junior Advocate", name: "Kesav Reddy", org: "Adusumilli & Associates" },
  { role: "Clerk", name: "Ramana Rao", org: "Adusumilli & Associates" },
  { role: "Firm Admin", name: "Padma Latha", org: "Adusumilli & Associates" },
  { role: "Client", name: "Kurella Govindu", org: "—" },
  { role: "ODR Neutral", name: "Justice (Retd.) P. V. Rao", org: "Amicus ODR Institute" },
];
